<div class="main-content">
  <div class="container-fluid">
    <div>
      <div class="card">
        <!--<div class="card-header card-header-primary card-header-icon">
            <h3 style="color: black">
              <b>SHIPMENT SCHEDULER <span *ngIf="soNumber">{{soNumber}}</span> </b>
              <hr style="border-color: #9c27b0; border-width: medium;" />
            </h3>
           </div>-->
        <div class="card-body">
          <!-- inicia buscador -->
          <div>
            <form class="navbar-form" (ngSubmit)="searchingSO()">
              <div style="width: 200px" class="input-group no-border">
                <input
                  type="text"
                  name="sosearch"
                  class="form-control"
                  [(ngModel)]="searchso"
                  [placeholder]="'Search SO ID#'"
                />

                <button
                  mat-raised-button
                  type="submit"
                  class="btn btn-white btn-round btn-just-icon"
                  [disabled]="
                    (searchso ? searchso.toString().length : 0) < 2 || searching
                  "
                >
                  <i
                    *ngIf="!searching"
                    class="fa fa-search"
                    aria-hidden="true"
                  ></i>
                  <i
                    *ngIf="searching"
                    class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"
                  ></i>
                  <div class="ripple-container"></div>
                </button>
              </div>
              <div *ngIf="showSONotFound" class="alert alert-danger">
                SO not found
              </div>
            </form>

            <ngx-skeleton-loader
              *ngIf="loadingShipments"
              count="5"
              appearance="line"
              animation="pulse"
            ></ngx-skeleton-loader>
            <dinamic-table
            *ngIf="!loadingShipments"
            [id]="'shipmentsScheduler'"
            [data]="shipmentsScheduler"
            [dbname]="'shipmentsScheduler'"
            [config]="options"
            [columnfilters]="filtros"
            [page]="shipmentsPage"
            [perPage]="shipmentsPerPage"
            [total_items_count]="shipmentsTotalItemsCount"
            [total_pages]="shipmentsTotalPages"
            (buscar)="onShipmentsBuscar($event)"
            (action_button)="action($event)"
            (newConfig)="updateConfig($event)"
            (rightClickAction)="handleShipmentsRightClick($event)"
        ></dinamic-table>
          </div>
          <hr style="border-color: #9c27b0; border-width: medium" />

          <div *ngIf="loadingShipment" style="position: relative">
            <app-loading></app-loading>
          </div>
          <div
            style="overflow: hidden !important"
            class="newshipmentform"
            *ngIf="shownewshipmentform"
          >
            <!-- inicia tab -->

            <div class="custom-tabs">
              <mat-tab-group
                style="overflow: hidden !important"
                #tabs
                animationDuration="0ms"
              >
                <mat-tab style="overflow: hidden !important">
                  <ng-template mat-tab-label>
                    <div class="icon-container">
                      <app-icon name="fi-rr-settings-sliders"></app-icon>
                    </div>
                    Shipment Settings
                  </ng-template>
                  <div class="row">
                    <div class="col-md-4">
                      <mat-form-field class="pt-4" appearance="outline">
                        <mat-label>Scheduled Ship Date</mat-label>
                        <input
                          matInput
                          [matDatepicker]="picker"
                          [(ngModel)]="shipment.dateShipment"
                          name="shipdateShipment"
                          required
                        />
                        <mat-datepicker-toggle
                          matSuffix
                          [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>

                      <mat-form-field appearance="outline">
                        <mat-label>Carrier</mat-label>
                        <select
                          id="carrier"
                          name="carrierform"
                          matNativeControl
                          (ngModelChange)="selectCarrier($event)"
                          required
                          [(ngModel)]="shipment.carrier"
                        >
                          <option value="null" disabled>Select Carrier</option>
                          <option
                            *ngFor="let carrier of carriersUnified"
                            [value]="carrier.id"
                          >
                            {{ carrier.name }} - {{ carrier.type }}
                          </option>
                        </select>
                      </mat-form-field>
                      <i
                        *ngIf="serviceTypeLoading"
                        class="fa fa-circle-o-notch fa-spin fa-fw"
                      ></i>
                      <mat-form-field
                        *ngIf="!serviceTypeLoading"
                        appearance="outline"
                      >
                        <mat-label>Service Type </mat-label>

                        <select
                          id="serviceType"
                          name="serviceTypeFrom"
                          matNativeControl
                          (ngModelChange)="selectService($event)"
                          required
                          [(ngModel)]="shipment.serviceType"
                        >
                          <option value="null" disabled>
                            Select Service Type
                          </option>
                          <option
                            *ngFor="let registro of serviceList"
                            [value]="registro.id"
                          >
                            {{ registro.name }}
                          </option>
                        </select>
                      </mat-form-field>
                      <mat-form-field
                        *ngIf="!serviceTypeLoading"
                        appearance="outline"
                      >
                        <mat-label>Payment Type</mat-label>
                        <select
                          id="paymentTypeForm"
                          name="paymentTypeForm"
                          matNativeControl
                          (ngModelChange)="selectPayment($event)"
                          required
                          [(ngModel)]="shipment.paymentType"
                        >
                          <option value="null" disabled>
                            Select Payment Type
                          </option>
                          <option
                            *ngFor="let registro of paymentList"
                            [value]="registro.id"
                          >
                            {{ registro.name }}
                          </option>
                        </select>
                      </mat-form-field>

                      <mat-form-field
                        *ngIf="!serviceTypeLoading"
                        appearance="outline"
                      >
                        <mat-label>Bill Account Number</mat-label>
                        <select
                          id="billAccountNumber"
                          name="billAccountNumberForm"
                          matNativeControl
                          (ngModelChange)="selectBillAccountNumber($event)"
                          required
                          [(ngModel)]="billAccountNumberSelection"
                        >
                          <option value="null" disabled>
                            Select Bill Account Number
                          </option>

                          <option
                            *ngFor="let registro of billAccountNumberList"
                            [value]="registro.id"
                          >
                            {{ registro.name }}
                          </option>
                        </select>
                      </mat-form-field>

                      <mat-form-field
                        *ngIf="billAccountNumberSelection === 'manual'"
                        appearance="outline"
                      >
                        <mat-label>* Enter Bill Account Number</mat-label>
                        <input
                          matInput
                          [(ngModel)]="manualBillAccountNumber"
                          (ngModelChange)="
                            shipment.billAccountNumber = manualBillAccountNumber
                          "
                          placeholder="Type account number"
                        />
                      </mat-form-field>

                      <mat-checkbox
                        [(ngModel)]="this.shipment.addFreightInvoice"
                        #freightCheckbox
                        [disabled]="!isSender"
                        class="checkboxstyle"
                        (change)="onFreightInvoiceChange($event)"
                      >
                        Add Freight Customer Invoice</mat-checkbox
                      >
                    </div>

                    <div class="col-md-4">
                      <!--
                   <mat-form-field appearance="outline" floatLabel="never" class="example-full-width has-label pt-4">
                    <mat-label>COD</mat-label>
                    <input
                      matInput
                      type="text"
                      id="cod"
                      name="cod"
                      [(ngModel)]="shipment.cod"
                      placeholder="COD"
                      [disabled]="codLocked"
                      required
                    />
                    <button
                      mat-icon-button
                      matSuffix
                      type="button"
                      (click)="toggleCODLock()"
                      [attr.aria-label]="codLocked ? 'Unlock COD' : 'Lock COD'"
                      [attr.title]="codLocked ? 'Unlock' : 'Lock'"
                    >
                      <mat-icon>{{ codLocked ? 'lock' : 'lock_open' }}</mat-icon>
                    </button>
                  </mat-form-field>
-->
                      <mat-form-field
                        appearance="outline"
                        floatLabel="never"
                        class="example-full-width has-label pt-4"
                      >
                        <mat-label>Declared Value</mat-label>
                        <input
                          matInput
                          type="text"
                          id="declaredValue"
                          name="declaredValueForm"
                          [(ngModel)]="shipment.declaredValue"
                          placeholder="Declared Value"
                        />
                      </mat-form-field>

                      <mat-form-field appearance="outline">
                        <mat-label>Warehouse</mat-label>
                        <select
                          id="warehouse"
                          name="warehouseForm"
                          matNativeControl
                          (ngModelChange)="selectWarehouse($event)"
                          required
                          [(ngModel)]="shipment.warehouse"
                        >
                          <option value="null" disabled>
                            Select Warehouse
                          </option>
                          <option
                            *ngFor="let registro of userLocations"
                            [value]="registro.id"
                          >
                            {{ registro.name }}
                          </option>
                        </select>
                      </mat-form-field>

                      <mat-form-field appearance="outline">
                        <mat-label>Unit of Measurement</mat-label>
                        <select
                          id="unitOfMeasurement"
                          name="unitOfMeasurementForm"
                          matNativeControl
                          (ngModelChange)="selectUnitOfMeasurementList($event)"
                          required
                          [(ngModel)]="shipment.unitOfMeasurement"
                        >
                          <option value="null" disabled>Select Unit</option>
                          <option
                            *ngFor="let registro of unitOfMeasurementList"
                            [value]="registro.name"
                          >
                            {{ registro.name }}
                          </option>
                        </select>
                      </mat-form-field>

                      <mat-form-field appearance="outline">
                        <mat-label>Unit of Dimensions</mat-label>
                        <select
                          id="unitDimension"
                          name="unitDimensionForm"
                          matNativeControl
                          (ngModelChange)="selectUnitDimensionList($event)"
                          required
                          [(ngModel)]="shipment.unitDimension"
                        >
                          <option value="null" disabled>Select Unit</option>
                          <option
                            *ngFor="let registro of unitDimensionList"
                            [value]="registro.name"
                          >
                            {{ registro.name | capitalizeFirst }}
                          </option>
                        </select>
                      </mat-form-field>

                      <div class="grisbg">
                        <mat-form-field appearance="outline">
                          <mat-label>Email</mat-label>
                          <input
                            matInput
                            [(ngModel)]="shipment.email"
                            placeholder="Type email account"
                          />
                        </mat-form-field>

                        <div style="padding: 8px">
                          <h4 style="font-size: 15px; font-weight: 400">
                            Email Notifications
                          </h4>
                          <div style="padding-left: 12px" class="row">
                            <div>
                              <mat-checkbox
                                class="small-label"
                                [(ngModel)]="shipment.notifications.exception"
                              >
                                Exception
                              </mat-checkbox>
                            </div>
                            <div>
                              <mat-checkbox
                                class="small-label"
                                [(ngModel)]="shipment.notifications.shipment"
                              >
                                Shipment
                              </mat-checkbox>
                            </div>
                          </div>

                          <div class="row" style="padding-left: 12px">
                            <div>
                              <mat-checkbox
                                class="small-label"
                                [(ngModel)]="shipment.notifications.delivery"
                              >
                                Delivery
                              </mat-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <mat-checkbox
                        (change)="onBlindDropShipWayBill($event)"
                        [(ngModel)]="shipment.blindDropShipWayBill"
                        style="
                          background-color: rgba(204, 204, 204, 0.15);
                          width: 100%;
                        "
                        class="checkboxstyle mt-4"
                        >Blind DropShip Way Bill</mat-checkbox
                      >

                      <mat-checkbox
                        [(ngModel)]="shipment.saturdayDelivery"
                        style="
                          background-color: rgba(204, 204, 204, 0.15);
                          width: 100%;
                        "
                        class="checkboxstyle mt-4"
                        >Saturday Delivery</mat-checkbox
                      >

                      <mat-checkbox
                        [(ngModel)]="shipment.residentDelivery"
                        style="
                          background-color: rgba(204, 204, 204, 0.15);
                          width: 100%;
                        "
                        class="checkboxstyle mt-4"
                        >Resident Delivery</mat-checkbox
                      >

                      <!--
    <mat-checkbox style="    background-color: rgba(204, 204, 204, 0.15);
    width: 100%;" class="checkboxstyle mt-4" (change)="onAddInsuranceChange($event)">Add Insurance</mat-checkbox>

    <mat-form-field *ngIf="shipment.addInsurance" appearance="outline" floatLabel="never" class="example-full-width has-label">
                    <mat-label>Insurance Amount</mat-label>
                    <input
                      matInput
                      type="text"
                      id="insuranceAmount"
                      name="insuranceAmountForm"
                      [(ngModel)]="shipment.insuranceCostAmount"
                      placeholder="Insurance Amount"
                    />
    </mat-form-field>

     <mat-form-field *ngIf="shipment.addInsurance" appearance="outline">
                  <mat-label>Insurance Currency</mat-label>
                      <select
                        id="insuranceCurreny"
                        name="insuranceCurrenyForm"
                        matNativeControl
                      
                        required
                        [(ngModel)]="shipment.insuranceCostCurrency"
                      >
                        <option value="null" disabled>Select Currency</option>
                        <option  value="USD">
                          USD
                        </option>
                        <option  value="MXN">
                          MXN
                        </option>
                        <option  value="CAD">
                          CAD
                        </option>
                      </select>
                </mat-form-field>

              -->

                      <mat-form-field
                        style="margin-top: 20px"
                        appearance="outline"
                      >
                        <mat-label>Signature</mat-label>
                        <select
                          id="signature"
                          name="signatureForm"
                          matNativeControl
                          (ngModelChange)="selectSignature($event)"
                          required
                          [(ngModel)]="shipment.signature"
                        >
                          <option value="null" disabled>
                            Select Signature
                          </option>
                          <option
                            *ngFor="let registro of signatureList"
                            [value]="registro.name"
                          >
                            {{ registro.name }}
                          </option>
                        </select>
                      </mat-form-field>
                    </div>
                  </div>
                </mat-tab>

                <mat-tab>
                  <ng-template mat-tab-label>
                    <div class="icon-container">
                      <app-icon name="fi-rr-address-book"> </app-icon>
                    </div>
                    Shipping Address
                  </ng-template>
                  <div class="flex-container mt-2">
                    <div class="form-container">
                      <h4>From</h4>

                      <div>
                        <div>
                          <mat-form-field appearance="outline">
                            <mat-label>Location</mat-label>
                            <select
                              id="shipfromlocation_id_form"
                              name="shipfromlocation_id"
                              matNativeControl
                              (ngModelChange)="selectLocationFrom($event)"
                              required
                              [(ngModel)]="shipment.shipfromlocation_id"
                            >
                              <option value="null" disabled>
                                Change Location
                              </option>
                              <option
                                *ngFor="let registro of userLocations"
                                [value]="registro.id"
                              >
                                {{ registro.name }}
                              </option>
                              <option value="headq">Headquarters</option>
                              <option value="other">One Time</option>
                            </select>
                          </mat-form-field>
                        </div>
                        <div class="flex-container">
                          <mat-form-field
                            appearance="outline"
                            floatLabel="never"
                            class="example-full-width has-label"
                          >
                            <mat-label>Company</mat-label>
                            <input
                              matInput
                              type="text"
                              id="FromCompanyValue"
                              name="FromCompanyValueForm"
                              [(ngModel)]="shipment.fromCompany"
                              placeholder="Company"
                              required
                            />
                          </mat-form-field>
                          <app-button-primary
                            [primary]="true"
                            (clickBtn)="oneTimeFrom()"
                            [disabled]="
                              shipment.status == 'completed' ||
                              shipment.status == 'Completed' ||
                              shipment.status == 'Voided' ||
                              shipment.status == 'Shipped'
                            "
                            label="One Time"
                          >
                          </app-button-primary>
                        </div>
                        <div class="flex-container">
                          <mat-form-field
                            appearance="outline"
                            floatLabel="never"
                            class="example-full-width has-label"
                          >
                            <mat-label>Name</mat-label>
                            <input
                              matInput
                              type="text"
                              id="FromNameValue"
                              name="FromNameValueForm"
                              [(ngModel)]="shipment.fromName"
                              placeholder="Name"
                              required
                            />
                          </mat-form-field>
                          <mat-form-field
                            appearance="outline"
                            floatLabel="never"
                            class="example-full-width has-label"
                          >
                            <mat-label>Phone</mat-label>
                            <input
                              matInput
                              type="text"
                              id="fromPhone"
                              name="fromPhoneForm"
                              [(ngModel)]="shipment.fromPhone"
                              placeholder="Phone"
                              required
                            />
                          </mat-form-field>
                        </div>
                        <div>
                          <mat-form-field
                            appearance="outline"
                            floatLabel="never"
                            class="example-full-width has-label"
                          >
                            <mat-label>Address</mat-label>
                            <input
                              matInput
                              type="text"
                              id="FromAddressValue"
                              name="FromAddressValueForm"
                              [(ngModel)]="shipment.fromAddress"
                              placeholder="Address"
                              required
                            />
                          </mat-form-field>
                        </div>
                        <div>
                          <mat-form-field
                            appearance="outline"
                            floatLabel="never"
                            class="example-full-width has-label"
                          >
                            <mat-label>Address #2</mat-label>
                            <input
                              matInput
                              type="text"
                              id="FromAddress2Value"
                              name="FromAddress2ValueForm"
                              [(ngModel)]="shipment.fromAddress2"
                              placeholder="Address Line 2"
                            />
                          </mat-form-field>
                        </div>
                        <div *ngIf="!loadingCountries">
                          <mat-form-field appearance="outline">
                            <mat-label>Country</mat-label>
                            <select
                              id="fromCountry"
                              name="fromCountryForm"
                              matNativeControl
                              (ngModelChange)="
                                getStates($event); shipment.fromState = ''
                              "
                              required
                              [(ngModel)]="shipment.fromCountry"
                            >
                              <option value="null" disabled>
                                Select Country
                              </option>
                              <option
                                *ngFor="let registro of countries"
                                [value]="registro.name"
                              >
                                {{ registro.name }}
                              </option>
                            </select>
                          </mat-form-field>
                        </div>
                        <div class="flex-container">
                          <mat-form-field
                            appearance="outline"
                            floatLabel="never"
                            class="example-full-width has-label"
                          >
                            <mat-label>City</mat-label>
                            <input
                              matInput
                              type="text"
                              id="fromCity"
                              name="fromCityForm"
                              [(ngModel)]="shipment.fromCity"
                              placeholder="City"
                              required
                            />
                          </mat-form-field>
                          <div class="w-100">
                            <i
                              *ngIf="loadingStates"
                              class="fa fa-circle-o-notch fa-spin fa-fw"
                            ></i>
                            <mat-form-field
                              *ngIf="statesfrom.length > 0 && !loadingStates"
                              appearance="outline"
                            >
                              <mat-label>State</mat-label>
                              <select
                                id="fromState"
                                name="fromStateForm"
                                matNativeControl
                                (ngModelChange)="selectFromState($event)"
                                required
                                [(ngModel)]="shipment.fromState"
                              >
                                <option value="null" disabled>
                                  Select State
                                </option>
                                <option
                                  *ngFor="let state of statesfrom"
                                  [value]="state.abbr"
                                >
                                  {{ state.abbr }} - {{ state.name }}
                                </option>
                              </select>
                            </mat-form-field>
                            <mat-form-field
                              *ngIf="statesfrom.length === 0"
                              appearance="outline"
                              floatLabel="never"
                              class="example-full-width has-label"
                            >
                              <mat-label>State</mat-label>
                              <input
                                matInput
                                type="text"
                                id="fromState"
                                name="fromStateForm"
                                [(ngModel)]="shipment.fromState"
                                placeholder="State"
                                required
                              />
                            </mat-form-field>
                          </div>
                          <mat-form-field
                            appearance="outline"
                            floatLabel="never"
                            class="example-full-width has-label"
                          >
                            <mat-label>Zip</mat-label>
                            <input
                              matInput
                              type="text"
                              id="fromZip"
                              name="fromZipForm"
                              [(ngModel)]="shipment.fromZip"
                              placeholder="Zip"
                              required
                            />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                    <div class="form-container">
                      <h4>To</h4>

                      <div>
                        <div>
                          <mat-form-field appearance="outline">
                            <mat-label>Location</mat-label>
                            <select
                              id="shiptolocation_id_form"
                              name="shiptolocation_id"
                              matNativeControl
                              (ngModelChange)="selectLocationTo($event)"
                              required
                              [(ngModel)]="shipment.shiptolocation_id"
                            >
                              <option value="null" disabled>
                                Change Location
                              </option>
                              <option
                                *ngFor="let registro of locations"
                                [value]="registro.id"
                              >
                                {{ registro.name }}
                              </option>
                              <option value="headq">Headquarters</option>
                              <option value="other">One Time</option>
                            </select>
                          </mat-form-field>
                        </div>
                        <div class="flex-container">
                          <mat-form-field
                            appearance="outline"
                            floatLabel="never"
                            class="example-full-width has-label"
                          >
                            <mat-label>Company</mat-label>
                            <input
                              matInput
                              type="text"
                              id="ToCompanyValue"
                              name="ToCompanyValueForm"
                              [(ngModel)]="shipment.toCompany"
                              placeholder="Company"
                              required
                            />
                          </mat-form-field>
                          <app-button-primary
                            [primary]="true"
                            (clickBtn)="oneTimeTo()"
                            [disabled]="
                              shipment.status == 'completed' ||
                              shipment.status == 'Completed' ||
                              shipment.status == 'Voided' ||
                              shipment.status == 'Shipped'
                            "
                            label="One Time"
                          >
                          </app-button-primary>
                        </div>
                        <div class="flex-container">
                          <mat-form-field
                            appearance="outline"
                            floatLabel="never"
                            class="example-full-width has-label"
                          >
                            <mat-label>Name</mat-label>
                            <input
                              matInput
                              type="text"
                              id="ToNameValue"
                              name="ToNameValueForm"
                              [(ngModel)]="shipment.toName"
                              placeholder="Name"
                              required
                            />
                          </mat-form-field>
                          <mat-form-field
                            appearance="outline"
                            floatLabel="never"
                            class="example-full-width has-label"
                          >
                            <mat-label>Phone</mat-label>
                            <input
                              matInput
                              type="text"
                              id="toPhone"
                              name="toPhoneForm"
                              [(ngModel)]="shipment.toPhone"
                              placeholder="Phone"
                              required
                            />
                          </mat-form-field>
                        </div>
                        <div>
                          <mat-form-field
                            appearance="outline"
                            floatLabel="never"
                            class="example-full-width has-label"
                          >
                            <mat-label>Address</mat-label>
                            <input
                              matInput
                              type="text"
                              id="ToAddressValue"
                              name="ToAddressValueForm"
                              [(ngModel)]="shipment.toAddress"
                              placeholder="Address"
                              required
                            />
                          </mat-form-field>
                        </div>
                        <div>
                          <mat-form-field
                            appearance="outline"
                            floatLabel="never"
                            class="example-full-width has-label"
                          >
                            <mat-label>Address #2</mat-label>
                            <input
                              matInput
                              type="text"
                              id="ToAddress2Value"
                              name="ToAddress2ValueForm"
                              [(ngModel)]="shipment.toAddress2"
                              placeholder="Address Line 2"
                            />
                          </mat-form-field>
                        </div>
                        <div *ngIf="!loadingCountries">
                          <mat-form-field appearance="outline">
                            <mat-label>Country</mat-label>
                            <select
                              id="toCountry"
                              name="toCountryForm"
                              matNativeControl
                              (ngModelChange)="
                                getStates2($event); shipment.toState = ''
                              "
                              required
                              [(ngModel)]="shipment.toCountry"
                            >
                              <option value="null" disabled>
                                Select Country
                              </option>
                              <option
                                *ngFor="let registro of countries"
                                [value]="registro.name"
                              >
                                {{ registro.name }}
                              </option>
                            </select>
                          </mat-form-field>
                        </div>

                        <div class="flex-container">
                          <mat-form-field
                            appearance="outline"
                            floatLabel="never"
                            class="example-full-width has-label"
                          >
                            <mat-label>City</mat-label>
                            <input
                              matInput
                              type="text"
                              id="toCity"
                              name="toCityForm"
                              [(ngModel)]="shipment.toCity"
                              placeholder="City"
                              required
                            />
                          </mat-form-field>

                          <mat-form-field
                            *ngIf="statesto.length > 0 && !loadingStates2"
                            appearance="outline"
                          >
                            <mat-label>State</mat-label>
                            <select
                              id="toState"
                              name="toStateForm"
                              matNativeControl
                              (ngModelChange)="selectToState($event)"
                              required
                              [(ngModel)]="shipment.toState"
                            >
                              <option value="null" disabled>
                                Select State
                              </option>
                              <option
                                *ngFor="let state of statesto"
                                [value]="state.abbr"
                              >
                                {{ state.abbr }} - {{ state.name }}
                              </option>
                            </select>
                          </mat-form-field>
                          <mat-form-field
                            *ngIf="statesto.length === 0"
                            appearance="outline"
                            floatLabel="never"
                            class="example-full-width has-label"
                          >
                            <mat-label>State</mat-label>
                            <input
                              matInput
                              type="text"
                              id="toState"
                              name="toStateForm"
                              [(ngModel)]="shipment.toState"
                              placeholder="State"
                              required
                            />
                          </mat-form-field>
                          <mat-form-field
                            appearance="outline"
                            floatLabel="never"
                            class="example-full-width has-label"
                          >
                            <mat-label>Zip</mat-label>
                            <input
                              matInput
                              type="text"
                              id="toZip"
                              name="toZipForm"
                              [(ngModel)]="shipment.toZip"
                              placeholder="Zip"
                              required
                            />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </div>

            <div *ngIf="tabs.selectedIndex === 1" style="display: flex">
              <app-button-primary
                [primary]="true"
                (clickBtn)="saveShipment()"
                iconLeft="save"
                label="Save Address"
                [disabled]="
                  !shipment.fromCompany ||
                  !shipment.fromName ||
                  !shipment.fromPhone ||
                  !shipment.fromAddress ||
                  !shipment.fromCountry ||
                  !shipment.fromCity ||
                  !shipment.fromState ||
                  !shipment.fromZip ||
                  !shipment.toCompany ||
                  !shipment.toName ||
                  !shipment.toPhone ||
                  !shipment.toCountry ||
                  !shipment.toAddress ||
                  !shipment.toCity ||
                  !shipment.toState ||
                  !shipment.toZip ||
                  saveLoading ||
                  shipment.status == 'completed' ||
                  shipment.status == 'Completed' ||
                  shipment.status == 'Voided' ||
                  shipment.status == 'Shipped'
                "
              >
              </app-button-primary>
            </div>

            <hr class="divider" />

            <h4>Shipment Items</h4>

            <div *ngIf="selectedIds.size" style="margin-bottom: 10px">
              <button
                mat-raised-button
                color="warn"
                [disabled]="selectedIds.size === 0"
                (click)="removeSelectedItems()"
                style="width: auto"
              >
                <span
                  class="material-icons"
                  style="vertical-align: middle; margin-right: 5px"
                >
                  delete
                </span>
                Remove Selected
              </button>
            </div>

            <!-- Shipment Items DataTable -->
            <ngx-skeleton-loader
              *ngIf="loadingShipmentItems"
              count="5"
              appearance="line"
              animation="pulse"
            ></ngx-skeleton-loader>
            <div *ngIf="!loadingShipmentItems" class="table-responsive">
              <table
                id="shipmentItems"
                class="table table-striped table-bordered table-sm w-100"
              >
                <thead>
                  <tr>
                    <th style="width: 34px">
                      <input
                        type="checkbox"
                        (change)="toggleSelectAll($event)"
                      />
                    </th>
                    <th>SO Line</th>
                    <th>Item</th>
                    <th>Mfgr</th>
                    <th>Serial Number</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Receive Status</th>
                    <th>Shipped Date</th>
                    <th>Ship Status</th>
                    <th style="width: 40px; text-align: center">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let r of shipmentItems; trackBy: trackByItemId">
                    <td>
                      <input
                        type="checkbox"
                        [checked]="selectedIds.has(r.id)"
                        (change)="toggleSelect(r.id, $event)"
                      />
                    </td>
                    <td>{{ r.soline }}</td>
                    <td>{{ r.item }}</td>
                    <td>{{ r.manufacturer }}</td>
                    <td>{{ r.serialNumber }}</td>
                    <td>{{ r.description }}</td>
                    <td>{{ r.status }}</td>
                    <td>{{ r.receivestatus }}</td>
                    <td>{{ r.shipdate | date: "MM-dd-yyyy" }}</td>
                    <td>{{ r.shipstatus }}</td>
                    <td class="text-center">
                      <button
                        type="button"
                        class="btn btn-link text-danger p-0"
                        title="Remove"
                        (click)="removeItem(r)"
                      >
                        <span
                          class="material-icons"
                          style="font-size: 20px; line-height: 20px"
                          >delete</span
                        >
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- botonera footer  *ngIf="tabs.selectedIndex === 0" -->
          <div>
            <div class="flex-container justify-content-between">
              <div class="flex-container">
                <app-button-primary
                  [outline]="true"
                  [disabled]="!soId || !soNumber || shownewshipmentform"
                  (clickBtn)="clickOnNew()"
                  label="New"
                >
                </app-button-primary>
                <app-button-primary
                  [outline]="true"
                  [disabled]="
                    !shipmentSelected ||
                    shipment.status == 'completed' ||
                    shipment.status == 'Completed' ||
                    shipment.status == 'Voided' ||
                    shipment.status == 'Shipped'
                  "
                  (clickBtn)="clickOnProcess()"
                  label="Process"
                >
                </app-button-primary>
                <app-button-primary
                  [outline]="true"
                  [disabled]="
                    !shownewshipmentform ||
                    shipment.status == 'Voided' ||
                    shipment.status == 'Shipped'
                  "
                  (clickBtn)="voidShipment(shipment.id)"
                  label="Void"
                >
                </app-button-primary>

                <app-button-primary
                  [outline]="true"
                  (clickBtn)="openAddItemsModal()"
                  [disabled]="
                    !shipment.id ||
                    shipment.status == 'Voided' ||
                    shipment.status == 'Shipped'
                  "
                  iconLeft="add"
                  label="Import Items From SO"
                >
                </app-button-primary>

                <!--
                 <div class="toolbar-button-container">
                          <div class="button-container">
                         
                            <button
                              matRipple
                              class="gts-btn-primary-outline main-button"
                              [disabled]="!shipment.id || shipment.status == 'Voided'"
                            >
                              <span class="gts-btn-text">Packing List</span>
                            </button>

                        
                            <button
                              matRipple
                              class="gts-btn-primary-outline spl"
                              [matMenuTriggerFor]="menu"
                              matMenuPositionX="after"
                              matMenuPositionY="above"
                              [disabled]="!shipment.id || shipment.status == 'Voided'"
                            >
                              <mat-icon class="iconArrow mat-icon show-overflow"
                                >arrow_drop_down</mat-icon
                              >
                            </button>

                
                            <mat-menu
                              #menu="matMenu"
                              class="custom-menu my-po-menu"
                            >
                              <div class="menu-item-container">
                                <button
                                  mat-button
                                  class="menu-option"
                                  [disabled]="!shipment.id || shipment.status == 'Voided'"
                                >
                                 
                                  <span class="btnText">Pick List</span>
                                </button>
                              </div>

                            
                            </mat-menu>
                          </div>
                        </div> -->
              </div>
              <div class="flex-container">
                <app-button-primary
                  [outline]="true"
                  [disabled]="!shipmentSelected"
                  (clickBtn)="clickOnCancelShip()"
                  label="Close"
                >
                </app-button-primary>
                <!--  shipmentItems.length === 0 || -->
                <app-button-primary
                  [primary]="true"
                  [disabled]="
                    !shownewshipmentform ||
                    saveLoading ||
                    !shipment.carrier ||
                    !shipment.dateShipment ||
                    !shipment.paymentType ||
                    !shipment.warehouse ||
                    !shipment.unitOfMeasurement ||
                    !shipment.signature ||
                    shipment.status == 'Voided' ||
                    shipment.status == 'Shipped' ||
                    !shipment.billAccountNumber ||
                    shipment.billAccountNumber === ''
                  "
                  (clickBtn)="saveShipment()"
                  iconLeft="save"
                  [label]="shipment.id ? 'Update' : 'Schedule'"
                >
                </app-button-primary>
              </div>
            </div>
          </div>
          <!-- fin botonera footer -->
        </div>
      </div>
    </div>
  </div>
</div>
